
import { z } from 'zod';

export const LoginFormSchema = z.object({
	email:    z.string().email(),
	password: z.string(),
});
export type LoginFormType = z.infer<typeof LoginFormSchema>;

export const RegisterFormSchema = z.object({
	email:           z.string().email(),
	name:            z.string().min(2),
	dateOfBirth:     z.coerce.date().nullable(),
	phoneNumber:     z.string().min(8),
	password:        z.string(),
	confirmPassword: z.string(),
}).refine(data => data.password === data.confirmPassword, { message: 'Passwords do not match' });
export type RegisterFormType = z.infer<typeof RegisterFormSchema>;

export  const ForgotPasswordFormSchema = z.object({ email: z.string().email() });
export type ForgotPasswordFormType = z.infer<typeof ForgotPasswordFormSchema>;

export const ResetPasswordFormSchema = z.object({
	password:        z.string(),
	confirmPassword: z.string(),
});
export type ResetPasswordFormType = z.infer<typeof ResetPasswordFormSchema>;

export const ChangePasswordFormSchema = z.object({
	email:              z.string().email(),
	password:           z.string(),
	newPassword:        z.string(),
	confirmNewPassword: z.string(),
});
export type ChangePasswordFormType = z.infer<typeof ChangePasswordFormSchema>;